import * as angular from "angular";
import {IController, IQService} from "angular";
import {AgentModel} from "../../angular/models/agent.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {AgentsService} from "../../services/agents-service.service";
import * as moment from "moment";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import * as _ from "lodash";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {ItinerariesService} from "../../../itineraries/services/itineraries-service.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {TaskStatusType} from "../../../tasks/types/taskStatus.type";
import {WorkingSlotsService} from "../../../working-slots/services/working-slots-service.service";
import {TagType} from "../../../tags/angular/types/tag.type";

export class AgentsPerformanceViewComponent implements IController {

  agentId: string;
  agentsGroup: string;
  agentsRef: any;
  selectedQuickFilterId?: string;
  tags: string[];
  branchIds: string[];
  agentSkills: string[];

  public agents: AgentModel[];
  public selectedAgent: AgentModel;
  private filtersConfig: any;

  public selectedAgentPerformance: any;
  public selectedAgentTasks: TaskModel[];
  public highlightedServiceId: string;
  public highlightedTaskId: string;
  public selectedTaskId: string;
  public pageName: string;
  public fromDate: number;
  public toDate: number;
  public configTimeZone: any;
  public taskStatusType: typeof TaskStatusType = TaskStatusType;
  public maxDate: any;
  public agentWorkingSlots: any;
  public isShowLegend: boolean = true;
  public agentIrregularities: any[] = [];
  public highlightedIrregularityId: any;
  public locationUpdates: any;
  public agentLocationCoords: any;

  constructor(private splitService: SplitService, private agentsService: AgentsService, private $state, private viewFilterSettingsService: ViewFilterSettingsService,
              private itinerariesService: ItinerariesService, private $agents, private workingSlotsService: WorkingSlotsService, private $q: IQService, private $timeout) {
  }

  $onInit() {
    this.agentsRef = this.$agents();

    if (!!this.agentId) {
      this.agentsRef.$asyncValues([this.agentId])
        .then((res) => {
          if (!!res.length) {
            this.selectedAgent = res[0];
            this.getAgentPerformance(this.selectedAgent.id);
            this.getAgentCompletedTasks(this.selectedAgent.id);
            this.getWorkingSlotsByAgents([this.selectedAgent.id]);
          }
        })
    }

    this.pageName = this.$state.current.name;
    this.maxDate = moment().valueOf();
    this.filtersConfig = {
      queryString: undefined,
      includeFilters: [
        SiteFiltersType.tags,
        SiteFiltersType.branchIds,
        SiteFiltersType.agentSkills
      ],
      bringozFilters: {
        [SiteFiltersType.tags]: this.tags,
        [SiteFiltersType.branchIds]: this.branchIds,
        [SiteFiltersType.agentSkills]: this.agentSkills,
      },
      queryMap: {
        tagType: TagType.Agent
      }
    }
    this.fromDate = moment().startOf('day').valueOf();
    this.toDate = moment().endOf('day').valueOf();
    this.configTimeZone = this.splitService.getTimeZone();

    this.getAgentsByGroup(this.agentsGroup);

  }

  onQueryChange(query) {
    this.filtersConfig.queryString = query;
    this.selectedAgent = undefined;
    this.selectedAgentPerformance = undefined;
    this.selectedAgentTasks = undefined;
    this.agentWorkingSlots = undefined;
  }

  onAgentSelect(agent) {
    this.selectedAgent = agent;
    this.selectedAgentPerformance = undefined;
    this.selectedAgentTasks = undefined;
    this.agentWorkingSlots = undefined;
    this.$state.go('.', {agentId: this.selectedAgent?.id}, {notify: false, reload: false});
    this.getAgentPerformance(agent.id);
    this.getAgentCompletedTasks(this.selectedAgent.id);
    this.getWorkingSlotsByAgents([this.selectedAgent.id]);
  }

  onAgentsGroupChange(agentsGroup) {
    this.agentsGroup = agentsGroup;
    this.splitService.setSiteItinerarySettings({agentsGroup: agentsGroup});
    this.getAgentsByGroup(agentsGroup);
  }

  onCloseSelectAgent() {
    this.selectedAgent = undefined;
    this.selectedAgentPerformance = undefined;
    this.selectedAgentTasks = undefined;
    this.agentWorkingSlots = undefined;
  }

  onHighlightedChanged(serviceId, highlightedTaskId) {
    this.highlightedServiceId = serviceId;
    this.highlightedTaskId = highlightedTaskId;
  }

  onHighlightedIrregularityChanged(irregularityId) {
    this.highlightedIrregularityId = irregularityId;
  }

  onTaskClickedChange(task) {
    if (this.selectedTaskId === task.id) {
      this.selectedTaskId = undefined;
    } else {
      this.selectedTaskId = task.id;
    }
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {

    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.filtersConfig.bringozFilters = filters;

    this.selectedAgent = undefined;
    this.selectedAgentPerformance = undefined;
    this.selectedAgentTasks = undefined;
    this.agentWorkingSlots = undefined;

    this._setStateParams();
  }

  onDatesBrowse(isNext) {
    let date;

    if (isNext) {
      if (moment(this.fromDate).add(1, 'day').valueOf() < this.maxDate) {
        date = moment(this.fromDate).add(1, 'day').valueOf()
      }
    } else {
      date = moment(this.toDate).subtract(1, 'day').valueOf()
    }

    this.onDateChange(date);
  }

  onDateChange(date) {
    this.fromDate = moment(date).startOf('day').valueOf();
    this.toDate = moment(date).endOf('day').valueOf();

    // this.selectedAgent = undefined;
    this.selectedAgentPerformance = undefined;
    this.selectedAgentTasks = undefined;
    this.agentWorkingSlots = undefined;

    if (!!this.selectedAgent) {
      this.getAgentPerformance(this.selectedAgent.id);
      this.getAgentCompletedTasks(this.selectedAgent.id);

      this.getWorkingSlotsByAgents([this.selectedAgent.id]);
    }
  }

  onChangeTimelineTimestamp(targetTimestamp) {
    const targetHour = new Date(targetTimestamp).getHours() + 1; // Convert 0-23 to 1-24

    if (!this.locationUpdates[targetHour] || this.locationUpdates[targetHour].length === 0) {
      return; // No data for this hour
    }

    // if (!this.locationUpdates || this.locationUpdates.length === 0) {
    //   return;
    // }

    let closest = null;
    let minDiff = Infinity;

    this.locationUpdates[targetHour].forEach(item => {
      let diff = Math.abs(item.timestamp - targetTimestamp);
      if (diff < minDiff) {
        minDiff = diff;
        closest = item;
      }
    });

    if (closest) {
      this.agentLocationCoords = closest;
    }

    this.$timeout(() => {
    }, 0);
  }

  private _setStateParams() {
    this.$state.go('.', {
      tags: this.filtersConfig.bringozFilters.tags,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      agentSkills: this.filtersConfig.bringozFilters.agentSkills
    }, {notify: false, reload: false, location: 'replace'});
  }

  private getAgentPerformance(agentId: string) {
    this.agentsService.getAgentPerformance(agentId, this.fromDate, this.toDate)
      .then((res: any) => {
        this.selectedAgentPerformance = res;
        // const locationUpdates = _.flatMap(res.agentRoutes, 'locationUpdates') || [];

        this.locationUpdates = {};

        for (let hour = 1; hour <= 24; hour++) {
          this.locationUpdates[hour] = [];
        }

        (_.flatMap(res.agentRoutes, 'locationUpdates') || []).forEach(item => {
          const hour = new Date(item.timestamp).getHours() + 1;
          this.locationUpdates[hour].push(item);
        });

        const locations = (_.flatMap(res.agentRoutes, 'locationUpdates') || []);
        if (!!locations.length) {
          this.agentLocationCoords = locations.reduce((max, item) => (item.timestamp > max.timestamp ? item : max), locations[0]);
        }

        // if (!!this.locationUpdates) {
        //   const locations = (_.flatMap(res.agentRoutes, 'locationUpdates') || []);
        //   this.agentLocationCoords = locations.reduce((max, item) => (item.timestamp > max.timestamp ? item : max), locations[0]);
        // }

        this.agentIrregularities = [];
        if (!!res.agentIrregularity) {
          const agentIrregularity = {
            ...res.agentIrregularity,
            agentId: this.agentId
          }
          this.agentIrregularities.push(agentIrregularity);
        }
      })
  }

  private getAgentCompletedTasks(agentId: string) {
    this.itinerariesService.getInActiveTasks(agentId, this.fromDate)
      .then((tasks) => {
        this.selectedAgentTasks = tasks;
      });
  }

  private getAgentsByGroup(agentsGroup) {

    this.agents = [];
    this.getAgentIdsByQuery(agentsGroup)
      .then((agentIds) => {
        return this.agentsRef.$asyncValues(agentIds);
      })
      .then((agents) => {
        if (this.agentsGroup === agentsGroup) {
          this.agents = agents;
        }
      })
  }

  private getAgentIdsByQuery(agentsGroup) {

    const queryPayload = {
      branchIds: this.branchIds || [],
      skill: this.agentSkills,
      tags: this.tags,
      group: undefined,
      status: undefined
    };

    if (!!agentsGroup) {
      if (_.isEqual(agentsGroup, 'Active')) {
        queryPayload.group = agentsGroup;
      }
      if (_.isEqual(agentsGroup, 'OffDuty')) {
        queryPayload.status = agentsGroup;
      }
    }

    return this.agentsRef.$getAll(queryPayload);
  }

  private getWorkingSlotsByAgents(agentIds, ignoreLoader?: boolean) {
    this.workingSlotsService.get(agentIds, this.fromDate, this.toDate, 1000, ignoreLoader)
      .then((agentWorkingSlots) => {
        this.agentWorkingSlots = agentWorkingSlots;
      })
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsPerformanceView', {
    bindings: {
      agentId: '<?',
      agentsGroup: '<',
      selectedQuickFilterId: '<',
      tags: '<',
      branchIds: '<?',
      agentSkills: '<?'
    },
    template: require('./agents-performance-view.html').default,
    controller: AgentsPerformanceViewComponent
  });
